module.exports = __webpack_public_path__ + "img/798ced8ea85131aeac3e881ba7cf3dfd9d9c0a7a.bba09612.png";